import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import GoBack from '@/components/common/go-back/GoBack';
import NoData from '@/components/common/no-data/NoData';
import FormServicesCategory from '@/components/forms/form-services-category/FormServicesCategory';
import { Skeleton } from '@/components/ui/skeleton';
import useEditServiceCaegory from '@/hooks/pages/useEditServiceCategory';

const EditServicesCategory = () => {
  const { sport, isError, isLoading, isPending, defaultValues, onSubmit } =
    useEditServiceCaegory();

  if (isLoading) {
    return (
      <>
        <GoBack />
        <Skeleton className="w-full h-[332px]" />
      </>
    );
  }

  if (!sport) {
    return (
      <>
        <GoBack />
        <NoData />
      </>
    );
  }

  if (isError) {
    return (
      <>
        <GoBack />
        <ErrorMessage />
      </>
    );
  }

  return (
    <>
      <GoBack />
      <div className="flex justify-center w-full">
        <FormServicesCategory
          onSubmit={onSubmit}
          isPending={isPending}
          defaultValues={defaultValues}
          isEdit={true}
          sportId={sport.id}
        />
      </div>
    </>
  );
};

export default EditServicesCategory;
